import { combineReducers } from '@reduxjs/toolkit';
import { appReducer } from './data/app/reducer';

export const dataReducer = combineReducers({
	app: appReducer,
});
